export const stepFun = (instanceId) => {
  return {
    OtpPhoneNumber: `/${instanceId}`,
    OtpPhoneCode: "/verify-phone",
    Purpose: "/welcome",
    BasicInfo: "/personal-information",
    Authentication: "/login",
    Address: "/address",
    Finances: "/questionnaire",
    BankDetails: "/bank-details",
    Bank: "/bank",
    PreScoring: "/pre-scoring",
    Decision: "/almost-done",
    RepaymentSchedule: "/approved",
    Card: "/verify-card",
    DirectDebit: "/direct-debit",
    Documents: "/sign-contract",
    Password: "/setup-password",
    End: "/success",
    Failure: "/failure",
    Rejected: "/rejected",
    Disabled: "/disabled"
  };
};

export const toasterConfig = {
  position: "top-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const FlowSteps = {
    OTP_PHONE_NUMBER: 'OtpPhoneNumber',
    OTP_PHONE_CODE: 'OtpPhoneCode',
    PURPOSE: 'Purpose',
    BASIC_INFO: 'BasicInfo',
    AUTHENTICATION: 'Authentication',
    ADDRESS: 'Address',
    FINANCES: 'Finances',
    BANK: 'Bank',
    BANK_DETAILS: 'BankDetails',
    PRE_SCORING: 'PreScoring',
    DECISION: 'Decision',
    REPAYMENT_SCHEDULE: 'RepaymentSchedule',
    CARD: 'Card',
    DIRECT_DEBIT: 'DirectDebit',
    DOCUMENTS: 'Documents',
    PASSWORD: 'Password',
    END: 'End',
    FAILURE: 'Failure',
    REJECTED: 'Rejected',
    DISABLED: 'Disabled',
};
